/**
 * TRDST High-End UI/UX — Custom JavaScript
 * Count-up animations, collection tabs, mobile bottom nav interactions
 */

(function () {
  'use strict';

  /* ===== Count-Up Animation (shared) ===== */
  function countUp(el, target) {
    var current = 0;
    var step = Math.max(1, Math.floor(target / 40));
    var interval = setInterval(function () {
      current += step;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      el.textContent = current.toLocaleString();
    }, 30);
  }

  function observeCountUps(container) {
    if (!container) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var numbers = entry.target.querySelectorAll('[data-count]');
            numbers.forEach(function (n) {
              var target = parseInt(n.getAttribute('data-count'), 10);
              if (target && !n.dataset.counted) {
                n.dataset.counted = '1';
                countUp(n, target);
              }
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(container);
  }

  /* ===== Helper: open search modal ===== */
  function openSearchModal() {
    var modal = document.querySelector('details-modal.header__search');
    if (!modal) return;
    /* Use the summary click to go through DetailsModal's proper open/close flow */
    var summary = modal.querySelector('summary');
    if (summary && !modal.querySelector('details').hasAttribute('open')) {
      summary.click();
    }
    var input = modal.querySelector('input[type="search"]');
    if (input) {
      setTimeout(function () { input.focus(); }, 100);
    }
  }

  /* ===== Collection Tabs ===== */
  function initCollectionTabs() {
    var section = document.getElementById('trdst-collection-tabs');
    if (!section) return;

    // Count-up for collection tabs header
    observeCountUps(section);

    // Tab switching
    var tabs = section.querySelectorAll('.collection-tabs__tab');
    var panels = section.querySelectorAll('.collection-tabs__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');

        // Deactivate all
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('active');
        });

        // Activate selected
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(target);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ===== Trust Section Count-up ===== */
  function initTrustSection() {
    observeCountUps(document.getElementById('trdst-trust'));
  }

  /* ===== Mobile Bottom Nav ===== */
  function initMobileBottomNav() {
    var nav = document.querySelector('.mobile-bottom-nav');
    if (!nav) return;

    // Category button - open drawer menu
    var categoryBtn = nav.querySelector('[data-action="open-drawer"]');
    if (categoryBtn) {
      categoryBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var drawer = document.querySelector('header-drawer');
        if (!drawer) return;
        var details = drawer.querySelector('details');
        var summary = details ? details.querySelector('summary') : null;
        if (!details || !summary) return;
        if (details.hasAttribute('open')) {
          drawer.closeMenuDrawer(e, summary);
        } else {
          details.setAttribute('open', '');
          drawer.openMenuDrawer(summary);
        }
      });
    }

    // Search button - open search modal
    var searchBtn = nav.querySelector('[data-action="open-search"]');
    if (searchBtn) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSearchModal();
      });
    }

  }

  /* ===== Desktop Inline Search Bar ===== */
  function initDesktopSearchBar() {
    var searchBar = document.querySelector('.header__search-bar-input');
    if (!searchBar) return;

    searchBar.addEventListener('click', function (e) {
      e.stopPropagation();
      openSearchModal();
      searchBar.blur();
    });
  }

  /* ===== Dynamic Brand Count (AJAX fallback when Liquid returns 0) ===== */
  function initBrandCount() {
    var el = document.getElementById('trdst-brand-count');
    if (!el) return;
    var liquidVal = parseInt(el.getAttribute('data-count'), 10);
    if (liquidVal > 0) return; // Liquid already has a valid count

    var pages = [];
    for (var i = 1; i <= 5; i++) pages.push(i);

    Promise.all(pages.map(function (p) {
      return fetch('/products.json?limit=250&page=' + p)
        .then(function (r) { return r.json(); })
        .catch(function () { return { products: [] }; });
    })).then(function (results) {
      var vendors = {};
      results.forEach(function (data) {
        if (data.products) {
          data.products.forEach(function (prod) {
            if (prod.vendor) vendors[prod.vendor] = true;
          });
        }
      });
      var count = Object.keys(vendors).length;
      if (count > 0) {
        el.setAttribute('data-count', count);
        el.dataset.counted = '';
        countUp(el, count);
      }
    });
  }

  /* ===== Staggered Reveal Animation (29CM-style) ===== */
  function initStaggeredReveal() {
    var targets = document.querySelectorAll(
      '.collection-tabs__header, .custom-3d-styling__content, .trust-section__header, .editorial-collection__text, .about-us__reveal, .pdp-stagger-reveal'
    );
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var children = entry.target.children;
          Array.prototype.forEach.call(children, function (child, i) {
            child.style.opacity = '0';
            child.style.transform = 'translateY(8px)';
            child.style.transition = 'opacity 0.7s ease ' + (i * 0.12) + 's, transform 0.7s ease ' + (i * 0.12) + 's';
            requestAnimationFrame(function () {
              child.style.opacity = '1';
              child.style.transform = 'translateY(0)';
            });
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    targets.forEach(function (s) { observer.observe(s); });
  }

  /* ===== Magazine Grid Progressive Loading ===== */
  function initMagazineProgressiveLoad() {
    var sections = document.querySelectorAll('[data-progressive-load]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var hiddenCards = section.querySelectorAll('.magazine-card--hidden');
      if (!hiddenCards.length) return;

      // "더보기" 버튼 모드: 버튼이 있으면 클릭으로 모든 hidden 카드 표시
      var loadMoreBtn = section.querySelector('.magazine-grid__load-more-btn');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
          var remaining = section.querySelectorAll('.magazine-card--hidden');
          remaining.forEach(function (card, i) {
            setTimeout(function () {
              card.classList.remove('magazine-card--hidden');
              card.classList.add('magazine-card--reveal');
            }, i * 60);
          });
          var wrapper = section.querySelector('.magazine-grid__load-more');
          if (wrapper) wrapper.classList.add('magazine-grid__load-more--hidden');
        });
        return;
      }

      // 스크롤 모드: IntersectionObserver 방식 (컬렉션 모드 등)
      var batchSize = 4;
      var currentIndex = 0;
      var grid = section.querySelector('.magazine-grid__cards');
      if (!grid) return;

      var sentinel = document.createElement('div');
      sentinel.className = 'magazine-grid__sentinel';
      sentinel.style.height = '1px';
      grid.parentNode.insertBefore(sentinel, grid.nextSibling);

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var batch = Array.prototype.slice.call(hiddenCards, currentIndex, currentIndex + batchSize);
          if (!batch.length) {
            observer.disconnect();
            if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
            return;
          }
          batch.forEach(function (card, i) {
            setTimeout(function () {
              card.classList.remove('magazine-card--hidden');
              card.classList.add('magazine-card--reveal');
            }, i * 80);
          });
          currentIndex += batchSize;
          if (currentIndex >= hiddenCards.length) {
            observer.disconnect();
            if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
          }
        });
      }, { rootMargin: '0px 0px 200px 0px', threshold: 0 });

      observer.observe(sentinel);
    });
  }

  /* ===== Magazine Grid — AJAX Product Thumbnails ===== */
  function initMagazineThumbnails() {
    var containers = document.querySelectorAll('.magazine-card__thumbnails[data-vendor-handle]');
    if (!containers.length) return;

    var delay = 0;
    containers.forEach(function (el) {
      var handle = el.getAttribute('data-vendor-handle');
      if (!handle) return;

      // 숨겨진 카드의 썸네일은 나중에 로드
      var card = el.closest('.magazine-card');
      if (card && card.classList.contains('magazine-card--hidden')) {
        el.setAttribute('data-thumb-pending', 'true');
        return;
      }

      // 제품 핸들 오버라이드 확인
      var p1 = el.getAttribute('data-thumb-product-1');
      var p2 = el.getAttribute('data-thumb-product-2');
      var p3 = el.getAttribute('data-thumb-product-3');

      delay += 300;
      if (p1 || p2 || p3) {
        setTimeout(function () { fetchSpecificProducts(el, [p1, p2, p3].filter(Boolean)); }, delay);
      } else {
        setTimeout(function () { fetchThumbnails(el, handle); }, delay);
      }
    });

    // "더보기" 클릭 시 숨겨진 카드의 썸네일도 로드
    var loadMoreBtn = document.querySelector('.magazine-grid__load-more-btn');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        setTimeout(function () {
          var pending = document.querySelectorAll('[data-thumb-pending="true"]');
          var d = 0;
          pending.forEach(function (el) {
            var h = el.getAttribute('data-vendor-handle');
            if (!h) return;
            d += 300;
            el.removeAttribute('data-thumb-pending');
            setTimeout(function () { fetchThumbnails(el, h); }, d);
          });
        }, 500);
      });
    }
  }

  function buildThumbHtml(p) {
    var img = p.images && p.images.length ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
    var price = formatKRW(p.variants[0].price);
    var compare = p.variants[0].compare_at_price;
    var priceHtml = compare && parseFloat(compare) > parseFloat(p.variants[0].price)
      ? '<span class="thumb-price--sale">' + price + '</span> <span class="thumb-price--was">' + formatKRW(compare) + '</span>'
      : price;
    var title = p.title;
    return '<a href="/products/' + p.handle + '" class="magazine-card__thumb" onclick="event.stopPropagation();">'
      + (img ? '<img src="' + img + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy" class="magazine-card__thumb-img">' : '')
      + '<div class="magazine-card__thumb-info">'
      + '<p class="magazine-card__thumb-title">' + title + '</p>'
      + '<p class="magazine-card__thumb-price">' + priceHtml + '</p>'
      + '</div></a>';
  }

  function fetchThumbnails(container, handle, retried) {
    fetch('/collections/' + handle + '/products.json?sort_by=best-selling&limit=3')
      .then(function (res) {
        if (res.status === 429 && !retried) {
          setTimeout(function () { fetchThumbnails(container, handle, true); }, 1500);
          return null;
        }
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        var html = '';
        data.products.slice(0, 3).forEach(function (p) { html += buildThumbHtml(p); });
        container.innerHTML = html;
      })
      .catch(function () {
        if (!retried) setTimeout(function () { fetchThumbnails(container, handle, true); }, 1500);
      });
  }

  function fetchSpecificProducts(container, handles) {
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.json')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var html = '';
      results.forEach(function (data) {
        if (!data || !data.product) return;
        html += buildThumbHtml(data.product);
      });
      if (html) container.innerHTML = html;
    });
  }

  function formatKRW(amount) {
    var n = Math.round(parseFloat(amount));
    return '₩' + n.toLocaleString('ko-KR');
  }

  /* ===== Banner Slider — infinite loop, 1 item at a time, 3s auto ===== */
  function initBannerSlider() {
    var sliders = document.querySelectorAll('[data-banner-slider]');
    sliders.forEach(function (slider) {
      var track = slider.querySelector('.magazine-grid__banner-track');
      var prevBtn = slider.querySelector('[data-banner-prev]');
      var nextBtn = slider.querySelector('[data-banner-next]');
      var currentEl = slider.querySelector('[data-banner-current]');
      if (!track || !prevBtn || !nextBtn) return;

      var originals = Array.from(track.querySelectorAll('.magazine-card--banner-slider-item'));
      var total = originals.length;
      if (total <= 1) { prevBtn.style.display = 'none'; nextBtn.style.display = 'none'; return; }

      /* Clone all items for seamless infinite loop */
      originals.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.removeAttribute('id');
        track.appendChild(clone);
      });
      var allItems = Array.from(track.querySelectorAll('.magazine-card--banner-slider-item'));

      function getFirstVisibleIndex() {
        var sl = track.scrollLeft;
        for (var i = 0; i < allItems.length; i++) {
          if (allItems[i].offsetLeft >= sl - 10) return i;
        }
        return 0;
      }

      function smoothScroll(idx) {
        track.scrollTo({ left: allItems[idx].offsetLeft, behavior: 'smooth' });
      }

      function instantScroll(idx) {
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = allItems[idx].offsetLeft;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.scrollSnapType = '';
            track.style.scrollBehavior = '';
          });
        });
      }

      /* After smooth animation, silently reset if on a clone */
      var resetTimer;
      function scheduleReset() {
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          var idx = getFirstVisibleIndex();
          if (idx >= total) instantScroll(idx - total);
        }, 400);
      }

      function updateUI() {
        var idx = getFirstVisibleIndex() % total;
        if (currentEl) currentEl.textContent = idx + 1;
      }

      function advance() {
        smoothScroll(getFirstVisibleIndex() + 1);
        scheduleReset();
      }

      function goBack() {
        var idx = getFirstVisibleIndex();
        if (idx <= 0) {
          instantScroll(total);
          requestAnimationFrame(function () { smoothScroll(total - 1); });
        } else {
          smoothScroll(idx - 1);
        }
      }

      prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goBack(); });
      nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); advance(); });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateUI, 80);
      }, { passive: true });

      window.addEventListener('resize', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateUI, 100);
      });

      /* Auto-slide every 3 seconds */
      var autoTimer = null;
      function startAuto() { stopAuto(); autoTimer = setInterval(advance, 3000); }
      function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
      slider.addEventListener('pointerenter', stopAuto);
      slider.addEventListener('pointerleave', startAuto);
      startAuto();

      updateUI();
    });
  }

  /* ===== PDP: Stagger Reveal (CSS class based) ===== */
  function initPdpStaggerReveal() {
    var pdpContainers = document.querySelectorAll('.pdp-stagger-reveal');
    if (!pdpContainers.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    pdpContainers.forEach(function (c) { observer.observe(c); });
  }

  /* ===== PDP: Mobile Sticky CTA Bar ===== */
  function initPdpStickyCta() {
    var stickyBar = document.getElementById('pdp-sticky-cta');
    var stickyBtn = document.getElementById('pdp-sticky-cta-btn');
    if (!stickyBar || !stickyBtn) return;

    var originalBtn = document.querySelector('.product-form__submit:not(.pdp-sticky-cta__btn)');
    if (!originalBtn) return;

    var priceEl = document.getElementById('pdp-sticky-cta-price');
    var variantEl = document.getElementById('pdp-sticky-cta-variant');

    // Observe original button visibility
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });

    observer.observe(originalBtn);

    // Update sticky bar when variant changes — listen to product-info's DOM update event
    function updateStickyFromDOM() {
      // Price — read from Dawn's already-updated price element
      if (priceEl) {
        var mainPrice = document.querySelector('.product .price-item--regular:not(s), .product .price-item--sale');
        if (mainPrice) priceEl.textContent = mainPrice.textContent.trim();
      }

      // Variant name — read currently selected option values from the DOM
      if (variantEl) {
        var container = document.querySelector('variant-selects');
        if (container) {
          var selectedOpts = [];
          container.querySelectorAll('.product-form__input').forEach(function (group) {
            var sel = group.querySelector('select');
            if (sel) {
              selectedOpts.push(sel.value);
            } else {
              var checked = group.querySelector('input[type="radio"]:checked');
              if (checked) selectedOpts.push(checked.value);
            }
          });
          if (selectedOpts.length) variantEl.textContent = selectedOpts.join(' / ');
        }
      }

      // Availability — read from the current variant
      var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (formInput && window.productData) {
        var cv = window.productData.variants.find(function (v) { return String(v.id) === String(formInput.value); });
        if (cv) {
          var hasSwatchBlocks = document.querySelectorAll('[data-swatch-block]').length > 0;
          if (!cv.available) {
            stickyBtn.disabled = true;
            stickyBtn.textContent = '품절';
          } else if (!hasSwatchBlocks) {
            stickyBtn.disabled = false;
            stickyBtn.textContent = '장바구니';
          }
        }
      }
    }

    // Update max-benefit price when variant changes
    function updateMaxBenefit() {
      var benefitEl = document.querySelector('[data-max-benefit-price]');
      if (!benefitEl) return;
      var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (formInput && window.productData) {
        var cv = window.productData.variants.find(function (v) { return String(v.id) === String(formInput.value); });
        if (cv) {
          var priceNum = parseInt(String(cv.price).replace(/[^0-9]/g, ''), 10);
          if (!priceNum || priceNum >= 99999999) return;
          var volumeRate = 1;
          if (priceNum >= 30000000) volumeRate = 0.97;
          else if (priceNum >= 20000000) volumeRate = 0.98;
          else if (priceNum >= 10000000) volumeRate = 0.99;
          var maxPrice = Math.floor(priceNum * 0.97 * volumeRate);
          benefitEl.textContent = '₩' + maxPrice.toLocaleString('ko-KR');
        }
      }
    }

    // product-info:variant-rendered fires after Dawn updates DOM (price, options, etc.)
    document.addEventListener('product-info:variant-rendered', function () {
      updateStickyFromDOM();
      updateMaxBenefit();
    });

    // Sticky CTA click → trigger original form submit (direct add to cart)
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      originalBtn.click();
    });
  }

  /* ===== Init All ===== */
  function init() {
    initCollectionTabs();
    initTrustSection();
    initMobileBottomNav();
    initDesktopSearchBar();
    initBrandCount();
    initStaggeredReveal();
    initMagazineProgressiveLoad();
    initMagazineThumbnails();
    initBannerSlider();
    initPdpStaggerReveal();
    initPdpStickyCta();
    observeCountUps(document.getElementById('trdst-about'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor compatibility
  document.addEventListener('shopify:section:load', function () {
    initMagazineProgressiveLoad();
  });
})();
